module.exports = __webpack_public_path__ + "h5/img/cygn10.2a21e1e7.png";